<template>
  <div class="grid grid-cols-1 gap-4 overflow-y-auto p-4 lg:grid-cols-2 xl:grid-cols-3">
    <CustomerForm :customer="selectedEntry.Customer"></CustomerForm>
    <FireExtinguisherCheck
      :fire-extinguisher-check="selectedEntry.fireExtinguisherCheck"
    ></FireExtinguisherCheck>
    <ProductBuySelector :bought-products="selectedEntry.boughtProducts" class="row-span-2"></ProductBuySelector>
    <div class="flex h-fit flex-col gap-2 rounded-2xl border-4 border-neutral-600 p-4">
      Notizen:
      <textarea
        name="notes"
        id="notes"
        class="h-48 w-full resize-none rounded-xl bg-neutral-600 p-2"
        v-model="selectedEntry.notes"
        @change="dataStore.update()"
      ></textarea>
    </div>
    <div
      class="grid h-fit grid-cols-3 justify-items-center rounded-2xl border-4 border-neutral-600 p-4"
    >
      <a
        :href="'bill/' + selectedEntry.id"
        target="_blank"
        class="aspect-square w-24 rounded-2xl bg-neutral-600 hover:bg-neutral-500"
        @click="
          if (!dateCheck(selectedEntry.billed)) selectedEntry.billed = new Date();
          dataStore.update();
        "
      >
        <img class="w-full p-2 invert" src="@/assets/bill.svg" />
      </a>
      <button
        class="aspect-square w-24 rounded-2xl bg-neutral-600 hover:bg-neutral-500 disabled:bg-neutral-700 disabled:hover:bg-neutral-700"
        :disabled="!dateCheck(selectedEntry.billed)"
        @click="
          if (!dateCheck(selectedEntry.paid)) selectedEntry.paid = new Date();
          dataStore.update();
        "
      >
        <img class="w-full p-4 invert" src="@/assets/pay.svg" />
      </button>
      <button
        class="aspect-square w-24 rounded-2xl bg-neutral-600 hover:bg-neutral-500 disabled:bg-neutral-700 disabled:hover:bg-neutral-700"
        @click="dialogState.shown = true"
        :disabled="dateCheck(selectedEntry.billed)"
      >
        <img class="w-full p-4 invert" src="@/assets/delete.svg" />
      </button>
      <ModalDialog
        v-model:shown="dialogState.shown"
        title="Löschen?"
        :callback="
          () => {
            dataStore.entries.splice(dataStore.entries.indexOf(selectedEntry), 1);
            dataStore.update();
            $emit('deselect');
            dialogState.shown = false;
          }
        "
        :btn-negative="{ text: 'Cancel' }"
        :btn-positive="{ text: 'OK' }"
      >
      </ModalDialog>

      <div>
        <button
          class="mx-6"
          v-if="dateCheck(selectedEntry.billed)"
          @click="
            selectedEntry.billed = new Date(0);
            dataStore.update();
          "
        >
          {{ dateTimeFormat.format(selectedEntry.billed) }}
        </button>
      </div>
      <div>
        <button
          class="mx-6"
          v-if="dateCheck(selectedEntry.paid)"
          @click="
            selectedEntry.paid = new Date(0);
            dataStore.update();
          "
        >
          {{ dateTimeFormat.format(selectedEntry.paid) }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { type entry } from "@/types";
import { useStore } from "../stores/dataStore";
import { ref } from "vue";
import CustomerForm from "./CustomerForm.vue";
import FireExtinguisherCheck from "./FireExtinguisherCheck.vue";
import ProductBuySelector from "./ProductBuySelector.vue";
import ModalDialog from "@/components/ModalDialog.vue";

const dialogState = ref({ shown: false });

const dataStore = useStore();

const props = defineProps<{
  selectedEntry: entry;
}>();

function dateCheck(date: Date) {
  return new Date(date).getTime() > new Date(dataStore.date).getTime();
}

const dateTimeFormat = new Intl.DateTimeFormat("de-DE", {
  day: "2-digit",
  month: "2-digit",
  year: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
});
</script>

<style scoped></style>
